import { LoadingRegion } from "@commerce/components/page";
import { SourcesScreen } from "@commerce/sources/SourcesScreen";
import { sourcesSearchSchema } from "@commerce/sources/search-params";
import { config } from "@repo/config";
import { AsyncBoundary } from "@shared/components/AsyncBoundary";
import { orpc } from "@shared/lib/orpc";
import { dehydrateForLoader, getServerQueryClient } from "@shared/lib/server";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_saas/app/_org/$organizationSlug/sources/",
)({
	validateSearch: sourcesSearchSchema,
	// The open run is a client query; the loader only warms the list.
	shouldReload: false,
	loader: async ({ context }) => {
		const organizationId = context.organization.id;
		const queryClient = getServerQueryClient();
		await queryClient.ensureQueryData(
			orpc.catalog.sources.list.queryOptions({
				input: { organizationId },
			}),
		);
		return {
			organizationId,
			dehydratedState: dehydrateForLoader(queryClient),
		};
	},
	head: () => ({
		meta: [{ title: `Sources and sync - ${config.appName}` }],
	}),
	component: SourcesPage,
});

function SourcesPage() {
	const { organizationId, dehydratedState } = Route.useLoaderData();
	return (
		<AsyncBoundary
			fallback={
				<LoadingRegion
					label="Loading sources"
					className="min-h-[50svh]"
				/>
			}
			dehydratedState={dehydratedState}
		>
			<SourcesScreen organizationId={organizationId} />
		</AsyncBoundary>
	);
}
